import { useEffect, useState } from "react";

type PdfReadySignalProps = {
    /**
     * When true, the component will signal IronPDF that rendering is complete,
     * but only after the browser has had a chance to paint.
     */
    when: boolean;
};

declare global {
    interface Window {
        ironpdf?: {
            notifyRender?: () => void;
        };
    }
}

export const PdfReadySignal = ({ when }: PdfReadySignalProps) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!when || ready) return;

        let cancelled = false;

        const rafId1 = requestAnimationFrame(() => {
            const rafId2 = requestAnimationFrame(() => {
                window.setTimeout(() => {
                    if (cancelled) return;

                    window.ironpdf?.notifyRender?.();

                    setReady(true);
                }, 100);
            });
            void rafId2;
        });

        return () => {
            cancelled = true;
            cancelAnimationFrame(rafId1);
        };
    }, [when, ready]);

    return ready ? <div id="pdf-ready" style={{ display: "none" }} /> : null;
};
